var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalContext } from "@/contexts";
import { getClient } from "@/graphql/ApolloClient";
import { useEnsureCountryInUrl } from "@/hooks/useEnsureCountryInUrl";
import { ApolloProvider } from "@apollo/client";
import { Flex, useRecipe } from "@chakra-ui/react";
import { useContext } from "react";
import { Footer } from "@/components/Footer";
import { SearchResults } from "@/components/SearchResults";
import { Top } from "@/components/Top/Top";
export var JobBoard = function () {
    var recipe = useRecipe({ key: "JobBoard" });
    var style = recipe();
    var properties = useContext(GlobalContext).properties;
    var graphQLUri = properties.graphQLUri;
    var client = getClient(graphQLUri, properties.placementId);
    // Ensure country is always present in URL
    useEnsureCountryInUrl();
    return (_jsxs(Flex, __assign({ css: style, id: "job-board-body" }, { children: [_jsx(Top, { modules: properties.modules }), _jsx(ApolloProvider, __assign({ client: client }, { children: _jsx(SearchResults, {}) })), properties.modules.footer && _jsx(Footer, {})] })));
};
